import { render, staticRenderFns } from "./bauablaufplan.vue?vue&type=template&id=4e5dc7c2&"
import script from "./bauablaufplan.vue?vue&type=script&lang=js&"
export * from "./bauablaufplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports